module.exports = __webpack_public_path__ + "media/pauwels.77299db9.mp4";